/**
 * ItemSuggest.jsx — 「새 항목 추가」 항목명 칸 아래 비슷한 항목 (2026-10-24 지도사 「등록할 때 키워드로 밑에 비슷한 게 딱 나오고,
 *  클릭하면 미리 등록해 놓은 가이드 링크 · 가이드 파일도 같이 한번에」)
 *  목록 = 서버 /api/templates/item-library — 템플릿 관리 「자주 쓰는 항목」에 등록한 것(맨 앞) + 지금까지 프로젝트 · 템플릿에 쓴 항목
 *  고르면 onPick({ label, type, required, sensitive, description, options, guides }) — 부르는 쪽이 항목을 바로 넣는다
 *  섹션은 오지 않는다(회사마다 달라 · 2026-10-28) — 부르는 쪽 지금 프로젝트의 섹션을 쓴다
 */
import { useEffect, useState } from "react";
import * as api from "./api";
import { G, A, ALt } from "./shared";
import { matchItems } from "./itemMatch";

export { matchItems };   // 예전 import 자리 호환 — 맞추기 규칙은 itemMatch.ts 하나

export default function ItemSuggest({ q, onPick }) {
  const [list, setList] = useState([]);
  useEffect(() => { let live = true; api.getItemLibrary().then((l) => { if (live) setList(l); }); return () => { live = false; }; }, []);
  const hits = matchItems(list, q, 6);
  if (!hits.length) return null;
  return (
    <div role="listbox" aria-label="비슷한 항목" style={{ margin: "0 0 8px", border: "1px solid " + G[200], borderRadius: 8, background: "#fff", overflow: "hidden" }}>
      <div style={{ padding: "6px 10px", fontSize: 10, color: G[500], background: G[50] || "#F9FAFB", borderBottom: "1px solid " + G[100] }}>누르면 가이드 링크 · 파일까지 한 번에 들어가요</div>
      {hits.map((x) => {
        const links = (x.guides || []).filter((g) => g.type === "link").length, files = (x.guides || []).filter((g) => g.type === "file").length;
        return (
          <button key={x.label} type="button" role="option" aria-selected="false" onMouseDown={(e) => e.preventDefault()} onClick={() => onPick(x)}
            style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", padding: "8px 10px", border: "none", borderTop: "1px solid " + G[100], background: "#fff", cursor: "pointer", textAlign: "left", fontFamily: "inherit" }}>
            <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, fontWeight: 600, color: G[700], overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{x.label}</span>
            {x.fixed && <span style={{ flexShrink: 0, fontSize: 9.5, fontWeight: 700, color: A, background: ALt, borderRadius: 8, padding: "2px 7px" }}>자주 쓰는 항목</span>}
            {(links > 0 || files > 0) && <span style={{ flexShrink: 0, fontSize: 10, color: G[500] }}>{[links ? "링크 " + links : "", files ? "파일 " + files : ""].filter(Boolean).join(" · ")}</span>}
          </button>
        );
      })}
    </div>
  );
}
